// NOTE: This file for component template function only
// All function name start from ctu_ (component template util) to indicate the function come from here

import { gu_getContentByCurrencyLanguage } from 'root/util/general-util';

import CompSS2 from './component-ss2-layout';

function _ignoreMobileKey() {
    return [
        'desktopGameTab',
        'homeAdsBanner',
        'homeBankStatus',
        'homeInfoFooter',
        'homeProviderBanner',
        'homeLiveStream',
        'homeReferral',
        'homeShareContact',
        'home-sport-banner-slider',
        'jackpot',
        'liveCasino',
        'aff-faq',
        'aff-funds-landing',
        // 'aff-home',
        'aff-add-bank-dialog',
        'affMenubar',
        'languageModal',
        'afterloginbar',
        'sidebanner',
        'homeLanding',
        'liveScore',
        'liveTV',
        'redirect-error',
        'register-success',
        'reset-password',
        'birthdate-verification-dialog',
        'ref-bonus-landing',
        'settingsMainWallet',
        'settingsWithdrawProgressBar',
        'history-landing',
        'delete-dialog',
        'member-info-verification-dialog',
        'select-bank-dialog',
        'settingsTabHeader',
        'transactionButton',
        'announcement-popup',
        'changePassword-popup',
        'loading',
        'login-alert-popup',
        'mobileWallet',
        'pageNotFound',
    ];
}

function _getDesktopAgentTemplateKey(type) {
    switch (type) {
        default:
            if (type.indexOf('-') !== -1) {
                type = _replaceDash(type);
            }
            type = 'agent_' + type + 'Template';
            return type;
    }
}

function _replaceDash(type) {
    let dashIndex = type.indexOf('-');
    let fontCapitalize = type.charAt(dashIndex + 1).toUpperCase();
    type = type.substring(0, dashIndex) + fontCapitalize + type.substring(dashIndex + 2, type.length);

    if (type.indexOf('-') !== -1) {
        return _replaceDash(type);
    } else {
        return type;
    }
}

export function ctu_getTemplateKey(type, viewType) {
    let templateRes = '';

    if (!_ignoreMobileKey().includes(type) && viewType === 'mobile') {
        templateRes = 'm_';
    }
    if (type.indexOf('-') !== -1) {
        type = _replaceDash(type);
    }
    templateRes = templateRes + type + 'Template';
    return templateRes;
}

function _getAgentTemplateKey(type, viewType) {
    if (viewType === 'mobile' && type === 'footer') {
        return null; // Agent portal doesn't support mobile view
    } else {
        return _getDesktopAgentTemplateKey(type);
    }
}

export function ctu_getCorrectComponents(allComponent, viewType) {
    let isMobile = false;
    if (viewType === 'mobile') {
        isMobile = true;
    }

    if (allComponent.desktop && allComponent.mobile) {
        return isMobile ? allComponent.mobile : allComponent.desktop;
    } else {
        // fallback use old implementation
        return allComponent;
    }
}

export function ctu_getCorrectComponent(allComponent, type, viewType, vm) {
    let templateKey = ctu_getTemplateKey(type, viewType);
    const windowTemplateKey = vm ? gu_getContentByCurrencyLanguage(vm, window[templateKey]) : window[templateKey];
    allComponent = ctu_getCorrectComponents(allComponent, viewType);
    // let filteredType = _replaceDash(type);

    if (templateKey && windowTemplateKey && allComponent[windowTemplateKey]) {
        return allComponent[windowTemplateKey];
    } else if (window.templateCode === 'ss2') {
        if (allComponent[CompSS2[templateKey]]) {
            return allComponent[CompSS2[templateKey]];
        }
        // Phase ? only will do dynamic changing
        // if (allComponent['d_' + filteredType + '_ss2']) {
        //     return allComponent['d_' + filteredType + '_ss2'];
        // }
    }

    return allComponent['default'];
}

export function ctu_getAgentCorrectComponent(allComponent, type, viewType) {
    let templateKey = _getAgentTemplateKey(type, viewType);
    allComponent = ctu_getCorrectComponents(allComponent, viewType);

    if (templateKey && window[templateKey] && allComponent[window[templateKey]]) {
        return allComponent[window[templateKey]];
    } else {
        return allComponent['default'];
    }
}
